export const data: any = [{
    "id": '1',
    "styleNumber": "STY_001",
    "productType": "test",
    "materialType": "Gold",
    "category": "Bracelet",
    "subCategory": "Men",
    "priceType": "SRP",
    "metalColor": "yellow",
    "shape": "test",
    "color": "yellow",
    "size": "2",
    "clarity": "24KT",
    "weight": "4",
    "status": true,
}]